import { useContext, useState } from "react";
import NavbarLogo from "../Assets/Logo";
import Switcher from "./Switcher";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const TealArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M0.555575 10.1617C0.165058 10.5522 0.16507 11.1854 0.555602 11.5759C0.946133 11.9664 1.5793 11.9664 1.96982 11.5759L0.555575 10.1617ZM12 1.13108C12 0.5788 11.5523 0.131093 11 0.131104L1.99998 0.131273C1.4477 0.131283 0.99999 0.579007 1 1.13129C1.00001 1.68358 1.44773 2.13128 2.00002 2.13127L10 2.13112L10.0002 10.1311C10.0002 10.6834 10.4479 11.1311 11.0002 11.1311C11.5525 11.1311 12.0002 10.6834 12.0002 10.1311L12 1.13108ZM1.96982 11.5759L11.7071 1.8382L10.2929 0.42401L0.555575 10.1617L1.96982 11.5759Z"
        fill="url(#paint0_linear_54_745)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_54_745"
          x1="1.48749"
          y1="1.42156"
          x2="11.0419"
          y2="10.8406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0CC8E8" />
          <stop offset="1" stopColor="#2DEEAA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const NavLinkComp = ({ text, href }) => {
  return (
    <NavLink
      to={href}
      className="text-[16px] medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
    >
      {text}
    </NavLink>
  );
};

const TryProductsButton = (props) => {
  return (
    <span className="inline-flex rounded-md shadow ml-2">
      <a
        {...props}
        className="inline-flex hover:cursor-pointer uppercase items-center px-4 py-2 border border-[#D6D6D6] dark:border-[#283642] text-base leading-6 bold rounded-none bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] dark:hover:text-white hover:text-[#111920] focus:outline-none focus:border-blue-700"
      >
        {/* <span className="">Try Products</span> */}
        Download App
        {/* {<ChevronUpGradientIcon open={props.open} />} */}
      </a>
    </span>
  );
};

const links = [
  {
    text: "How IzzyAI Can Help?",
    href: "#help",
  },
  {
    text: "Company",
    href: "https://vtm.ai/",
  },
  {
    text: "Sign Intrue",
    href: "/login",
  },
];

function Navbar() {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const [isMobileDropdown, setIsMobileDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);


  const toogle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    window.location.reload();
    toast.success("Logout Successfully");
  }

  return (
    <>
      <nav className="relative flex items-center justify-between sm:h-10 md:h-16 py-6 px-8 w-full dark:bg-[#111920]">
        <div className="flex items-center">
          <div className="flex items-center justify-between w-full md:w-auto">
            <a href="/" aria-label="Home">
              <NavbarLogo />
            </a>
          </div>
        </div>
        <div className="hidden lg:flex 2xl:space-x-10 xl:space-x-5 lg:space-x-3 md:space-x-1 ">
          <a
            href="#help"
            className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] flex items-center  medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
          >
            How IzzyAI Can Help?
          </a>
          <NavLink
            to="https://vtm.ai/"
            className=" 2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] flex items-center medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
          >
            Company
          </NavLink>
          <NavLink
            to="/pricing"
            className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] flex items-center medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
          >
            Plans & Pricing
          </NavLink>
          <NavLink
            to="/contactus"
            className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] flex items-center medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
          >
            Demo
          </NavLink>
          <NavLink
            to="/signup-for-waitlist"
            className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] flex items-center medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
          >
            Sign Up For Waitlist
          </NavLink>
          {
            isAuthenticated && 
          <NavLink
            to="/account"
            className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] flex items-center medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
          >
            Account
          </NavLink>
          }
         



          {!isAuthenticated ?
            (<p
              onClick={() => {
                navigate("/login");
                setIsMobileMenuOpen(false);
              }}
              className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] hover:cursor-pointer medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
            >
              Sign In
            </p>)
            :
            (<p
              onClick={handleLogout}
              className="2xl:text-[16px] xl:text-[16px] lg:text-[14px] text-[16px] hover:cursor-pointer medium uppercase text-black dark:text-white hover:text-cyan-500 dark:hover:text-cyan-500 transition duration-150 ease-in-out"
            >
              Logout
            </p>)
          }


        </div>
        <div className="relative hidden lg:flex md:items-center ">
          {/* <button
            className="text-white bg-gray-500 dark:text-gray-500 dark:hover:text-gray-400 dark:bg-white hover:bg-gray-400 focus:outline-none focus:ring-0 font-medium rounded-full w-10 h-10 flex items-center justify-center"
            type="button"
          >
            <FontAwesomeIcon icon={faUser} />
          </button> */}


          <Switcher />
          <TryProductsButton open={isOpen} href="/" />
          {isOpen && (
            <div className="absolute w-[225px] h-full top-14 -left-10 dark:text-white">
              <a
                href="#"
                className="text-[16px] px-6 py-4 h-auto bg-white dark:bg-[#24303A] w-full flex justify-between items-center"
              >
                <span>IZZYAI</span>
                <TealArrow />
              </a>
              <a
                href="#"
                className="text-[16px] px-6 py-4 h-auto bg-white dark:bg-[#24303A] w-full flex justify-between items-center"
              >
                <span>VICTOR AI</span>
                <TealArrow />
              </a>
            </div>
          )}
        </div>

        <div className="-mr-2 flex items-center lg:hidden">
          <Switcher />
          <button
            type="button"
            onClick={() => toogle()}
            id="main-menu"
            aria-label="Main menu"
            aria-haspopup="true"
            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 dark:text-white hover:text-gray-500 dark:bg-[#1B2731] focus:outline-none focus:bg-gray-100 focus:text-gray-500"
          >
            <svg
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>

      </nav>
      <div
        className={`${isMobileMenuOpen ? "block" : "hidden"
          } lg:hidden px-2 pt-2 pb-4`}
      >
        <a
          href="#help"
          onClick={() => {
            setIsMobileMenuOpen(false);
          }}
          className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
        >
          How Izzy AI Can Help?
        </a>
        <a
          href="https://vtm.ai/"
          className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
        >
          Company
        </a>
        <p
          onClick={() => {
            navigate("/pricing");
            setIsMobileMenuOpen(false);
          }}
          className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
        >
          Plans & Pricing
        </p>
        <NavLink
          to="/contactus"
          onClick={() => {
            setIsMobileMenuOpen(false);
          }}
          className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
        >
          Demo
        </NavLink>
        <NavLink
          to="/signup-for-waitlist"
          onClick={() => {
            setIsMobileMenuOpen(false);
          }}
          className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
        >
          Sign Up For Waitlist
        </NavLink>
        {
            isAuthenticated && 
          <NavLink
            to="/account"
            onClick={() => {
              setIsMobileMenuOpen(false);
            }}
            className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
          >
            Account
          </NavLink>
          }
        
        {!isAuthenticated ?
          (<p
            onClick={() => {
              navigate("/login");
              setIsMobileMenuOpen(false);
            }}
            className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
          >
            Sign In
          </p>)
          :
          (<p
            onClick={handleLogout}
            className="hover:cursor-pointer block text-center text-black dark:text-white hover:text-teal-500 hover:shadow-lg px-6 py-3"
          >
            Logout
          </p>)
        }

        <div className="relative w-full text-black dark:text-white">
          {/* <button
            onClick={() => setIsMobileDropdown(!isMobileDropdown)}
            className="flex items-center text-center  hover:text-teal-500 hover:shadow-lg px-6 py-3 mx-auto"
          >
            <span>Try Products</span>
            <ChevronDownIcon />
          </button> */}
          <div className="flex justify-center">
            <TryProductsButton href="/" />
          </div>

          {/* {isMobileDropdown && (
            <div className="absolute h-full top-14 w-full shadow-md">
              <a
                href="#"
                className="text-[16px] px-6 py-4 h-auto bg-white dark:bg-[#24303A] w-full flex justify-between items-center"
              >
                <span>IZZY AI</span>
                <TealArrow />
              </a>
              <a
                href="#"
                className="text-[16px] px-6 py-4 h-auto bg-white dark:bg-[#24303A] w-full flex justify-between items-center"
              >
                <span>VICTOR AI</span>
                <TealArrow />
              </a>
            </div>
          )} */}
        </div>
      </div>
    </>
  );
}

export default Navbar;

